<!-- eslint-disable tailwindcss/no-custom-classname -->
<template>
	<div>
		<h1 style="padding-top: 2pt; text-indent: 0pt; text-align: center">
			POLÍTICA DE PRIVACIDADE E PROTEÇÃO DE DADOS PESSOAIS
		</h1>
		<p style="padding-top: 4pt; text-indent: 0pt; text-align: left"><br /></p>
		<div class="flex w-full justify-center">
			<p class="s1 updated-at">
				Última atualização em outubro de 2024<span class="p">.</span>
			</p>
		</div>
		<p style="padding-top: 4pt; text-indent: 0pt; text-align: left"><br /></p>
		<p
			style="
				padding-left: 5pt;
				text-indent: 0pt;
				line-height: 114%;
				text-align: justify;
			"
		>
			Nós da <b>Pilar </b>estamos comprometidos em seguir as diretrizes da Lei
			n. 13.709/2018, mais conhecida como Lei Geral de Proteção de Dados ou
			“<u>LGPD</u>”, e em te informar sobre como utilizamos os seus Dados
			Pessoais enquanto Você utiliza a nossa Plataforma pela web e aplicativo
			mobile e navega pelo nosso
			<a :href="urlSouPilar" class="a" target="_blank"
				><span
					style="
						color: #0462c1;
						font-family: Calibri, sans-serif;
						font-style: normal;
						font-weight: normal;
						text-decoration: underline;
						font-size: 11pt;
					"
					>site</span
				></a
			>. Para isso, elaboramos essa Política de Privacidade com todas as
			informações sobre o nosso acesso, uso, armazenamento e outros tópicos
			envolvendo o tratamento de seus Dados Pessoais.
		</p>
		<p style="padding-top: 2pt; text-indent: 0pt; text-align: left"><br /></p>
		<p
			style="
				padding-left: 5pt;
				text-indent: 0pt;
				line-height: 114%;
				text-align: justify;
			"
		>
			As informações aqui destacadas se aplicam aos serviços prestados por meio
			do nossa plataforma disponível para uso e acesso em dispositivos
			eletrônicos (celular, tablet, computador) pela
			<b>PILAR SOLUÇÕES IMOBILIÁRIAS LTDA</b>, pessoa jurídica de direito
			privado, devidamente inscrita no CNPJ/MF sob o nº 44.139.018/0001-44, com
			sede à Rua Dr. Fernandes Coelho, nº 85, 9º andar, CEP 05423-040, São
			Paulo, Estado de São Paulo (“<b>Pilar</b>”).
		</p>
		<p style="padding-top: 2pt; text-indent: 0pt; text-align: left"><br /></p>
		<p
			style="
				padding-left: 5pt;
				text-indent: 0pt;
				line-height: 114%;
				text-align: justify;
			"
		>
			Para melhor entender como funciona nossa Plataforma, a proteção dos seus
			Dados Pessoais e a garantia de sua privacidade, recomendamos a leitura em
			conjunto aos termos e condições que podem ser disponibilizados pela Pilar.
		</p>
		<p style="padding-top: 2pt; text-indent: 0pt; text-align: left"><br /></p>
		<p
			style="
				padding-left: 5pt;
				text-indent: 0pt;
				line-height: 114%;
				text-align: justify;
			"
		>
			Caso Você tenha qualquer dúvida ou solicitação, entre em contato com a
			<b>Pilar </b
			><a href="mailto:privacidade@soupilar.com.br" class="a" target="_blank"
				>pelo canal </a
			><a href="mailto:privacidade@soupilar.com.br" target="_blank"
				>privacidade@soupilar.com.br.</a
			>
		</p>
		<p style="text-indent: 0pt; text-align: left"><br /></p>
		<table
			style="border-collapse: collapse; margin-left: 5.5pt"
			cellspacing="0"
		>
			<tbody>
				<tr style="height: 31pt">
					<td
						style="
							width: 225pt;
							border-top-style: solid;
							border-top-width: 1pt;
							border-top-color: #0f4f3c;
							border-left-style: solid;
							border-left-width: 1pt;
							border-left-color: #0f4f3c;
							border-bottom-style: solid;
							border-bottom-width: 1pt;
							border-bottom-color: #0f4f3c;
							border-right-style: solid;
							border-right-width: 1pt;
							border-right-color: #0f4f3c;
						"
					>
						<p
							class="s4"
							style="
								padding-top: 8pt;
								padding-right: 4pt;
								text-indent: 0pt;
								text-align: center;
							"
						>
							QUEM SOMOS?
						</p>
					</td>
					<td
						style="
							width: 226pt;
							border-top-style: solid;
							border-top-width: 1pt;
							border-top-color: #0f4f3c;
							border-left-style: solid;
							border-left-width: 1pt;
							border-left-color: #0f4f3c;
							border-bottom-style: solid;
							border-bottom-width: 1pt;
							border-bottom-color: #0f4f3c;
							border-right-style: solid;
							border-right-width: 1pt;
							border-right-color: #0f4f3c;
						"
					>
						<p
							class="s4"
							style="padding-left: 5pt; text-indent: 0pt; text-align: left"
						>
							PILAR SOLUÇÕES IMOBILIÁRIAS LTDA
						</p>
						<p
							class="s5"
							style="
								padding-top: 2pt;
								padding-left: 5pt;
								text-indent: 0pt;
								text-align: left;
							"
						>
							(“<b>Pilar</b>”), CNPJ: 44.139.018/0001-44.
						</p>
					</td>
				</tr>
				<tr style="height: 30pt">
					<td
						style="
							width: 225pt;
							border-top-style: solid;
							border-top-width: 1pt;
							border-top-color: #0f4f3c;
							border-left-style: solid;
							border-left-width: 1pt;
							border-left-color: #0f4f3c;
							border-bottom-style: solid;
							border-bottom-width: 1pt;
							border-bottom-color: #0f4f3c;
							border-right-style: solid;
							border-right-width: 1pt;
							border-right-color: #0f4f3c;
						"
					>
						<p
							class="s4"
							style="
								padding-top: 7pt;
								padding-right: 4pt;
								text-indent: 0pt;
								text-align: center;
							"
						>
							ONDE NÓS ESTAMOS LOCALIZADOS?
						</p>
					</td>
					<td
						style="
							width: 226pt;
							border-top-style: solid;
							border-top-width: 1pt;
							border-top-color: #0f4f3c;
							border-left-style: solid;
							border-left-width: 1pt;
							border-left-color: #0f4f3c;
							border-bottom-style: solid;
							border-bottom-width: 1pt;
							border-bottom-color: #0f4f3c;
							border-right-style: solid;
							border-right-width: 1pt;
							border-right-color: #0f4f3c;
						"
					>
						<p
							class="s5"
							style="padding-left: 5pt; text-indent: 0pt; text-align: left"
						>
							Rua Dr. Fernandes Coelho, nº 85, 9º andar, CEP
						</p>
						<p
							class="s5"
							style="
								padding-top: 2pt;
								padding-left: 5pt;
								text-indent: 0pt;
								text-align: left;
							"
						>
							05423-040, São Paulo, Estado de São Paulo.
						</p>
					</td>
				</tr>
				<tr style="height: 170pt">
					<td
						style="
							width: 225pt;
							border-top-style: solid;
							border-top-width: 1pt;
							border-top-color: #0f4f3c;
							border-left-style: solid;
							border-left-width: 1pt;
							border-left-color: #0f4f3c;
							border-bottom-style: solid;
							border-bottom-width: 1pt;
							border-bottom-color: #0f4f3c;
							border-right-style: solid;
							border-right-width: 1pt;
							border-right-color: #0f4f3c;
						"
					>
						<p style="text-indent: 0pt; text-align: left"><br /></p>
						<p
							class="s4"
							style="padding-right: 4pt; text-indent: 0pt; text-align: center"
						>
							QUAIS DADOS NÓS UTILIZAMOS?
						</p>
					</td>
					<td
						style="
							width: 226pt;
							border-top-style: solid;
							border-top-width: 1pt;
							border-top-color: #0f4f3c;
							border-left-style: solid;
							border-left-width: 1pt;
							border-left-color: #0f4f3c;
							border-bottom-style: solid;
							border-bottom-width: 1pt;
							border-bottom-color: #0f4f3c;
							border-right-style: solid;
							border-right-width: 1pt;
							border-right-color: #0f4f3c;
						"
					>
						<p
							class="s5"
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: left;
							"
						>
							Nós tratamos Dados Pessoais de diferentes origens, como:
						</p>
						<ul id="l1">
							<li data-list-text="●">
								<p
									class="s4"
									style="
										padding-left: 5pt;
										padding-right: 9pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Dados de identificação
									<span class="s5">(nome, CPF/RG, e-mail);</span>
								</p>
							</li>
							<li data-list-text="●">
								<p
									class="s4"
									style="
										padding-left: 5pt;
										padding-right: 9pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Dados financeiros e fiscais
									<span class="s5"
										>(certidão sobre imposto de renda, certidão negativa de
										débito);</span
									>
								</p>
							</li>
							<li data-list-text="●">
								<p
									class="s4"
									style="
										padding-left: 5pt;
										padding-right: 9pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Dados profissionais
									<span class="s5">(número do CRECI); e</span>
								</p>
							</li>
							<li data-list-text="●">
								<p
									class="s4"
									style="
										padding-left: 41pt;
										text-indent: -35pt;
										text-align: justify;
									"
								>
									Dados de navegação <span class="s5">(histórico de</span>
								</p>
							</li>
						</ul>
						<p
							class="s5"
							style="
								padding-top: 2pt;
								padding-left: 5pt;
								text-indent: 0pt;
								text-align: left;
							"
						>
							acesso, IP, registro de hora e data).
						</p>
					</td>
				</tr>
				<tr style="height: 139pt">
					<td
						style="
							width: 225pt;
							border-top-style: solid;
							border-top-width: 1pt;
							border-top-color: #0f4f3c;
							border-left-style: solid;
							border-left-width: 1pt;
							border-left-color: #0f4f3c;
							border-bottom-style: solid;
							border-bottom-width: 1pt;
							border-bottom-color: #0f4f3c;
							border-right-style: solid;
							border-right-width: 1pt;
							border-right-color: #0f4f3c;
						"
					>
						<p style="text-indent: 0pt; text-align: left"><br /></p>
						<p
							class="s4"
							style="padding-right: 4pt; text-indent: 0pt; text-align: center"
						>
							PARA QUAIS FINALIDADES?
						</p>
					</td>
					<td
						style="
							width: 226pt;
							border-top-style: solid;
							border-top-width: 1pt;
							border-top-color: #0f4f3c;
							border-left-style: solid;
							border-left-width: 1pt;
							border-left-color: #0f4f3c;
							border-bottom-style: solid;
							border-bottom-width: 1pt;
							border-bottom-color: #0f4f3c;
							border-right-style: solid;
							border-right-width: 1pt;
							border-right-color: #0f4f3c;
						"
					>
						<p
							class="s5"
							style="
								padding-left: 5pt;
								padding-right: 9pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Nós utilizamos os seus Dados Pessoais para diferentes finalidades,
							dentre as quais se destacam:
						</p>
						<ul id="l2">
							<li data-list-text="●">
								<p
									class="s5"
									style="
										padding-left: 41pt;
										padding-right: 9pt;
										text-indent: -18pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Cadastro de uma conta em nossa Plataforma;
								</p>
							</li>
							<li data-list-text="●">
								<p
									class="s5"
									style="
										padding-left: 41pt;
										text-indent: -17pt;
										text-align: left;
									"
								>
									Processo de <i>KYC </i>sobre os Clientes;
								</p>
							</li>
							<li data-list-text="●">
								<p
									class="s5"
									style="
										padding-top: 2pt;
										padding-left: 41pt;
										text-indent: -17pt;
										text-align: left;
									"
								>
									Realização de <i>workshops </i>e eventos;
								</p>
							</li>
							<li data-list-text="●">
								<p
									class="s5"
									style="
										padding-left: 41pt;
										padding-right: 9pt;
										text-indent: -18pt;
										line-height: 16pt;
										text-align: left;
									"
								>
									Gerenciamento de <i>leads </i>por parte do Corretor.
								</p>
							</li>
						</ul>
					</td>
				</tr>
				<tr style="height: 169pt">
					<td
						style="
							width: 225pt;
							border-top-style: solid;
							border-top-width: 1pt;
							border-top-color: #0f4f3c;
							border-left-style: solid;
							border-left-width: 1pt;
							border-left-color: #0f4f3c;
							border-bottom-style: solid;
							border-bottom-width: 1pt;
							border-bottom-color: #0f4f3c;
							border-right-style: solid;
							border-right-width: 1pt;
							border-right-color: #0f4f3c;
						"
					>
						<p style="text-indent: 0pt; text-align: left"><br /></p>
						<p
							class="s4"
							style="padding-right: 4pt; text-indent: 0pt; text-align: center"
						>
							POR QUANTO TEMPO?
						</p>
					</td>
					<td
						style="
							width: 226pt;
							border-top-style: solid;
							border-top-width: 1pt;
							border-top-color: #0f4f3c;
							border-left-style: solid;
							border-left-width: 1pt;
							border-left-color: #0f4f3c;
							border-bottom-style: solid;
							border-bottom-width: 1pt;
							border-bottom-color: #0f4f3c;
							border-right-style: solid;
							border-right-width: 1pt;
							border-right-color: #0f4f3c;
						"
					>
						<p
							class="s5"
							style="
								padding-left: 5pt;
								padding-right: 9pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Até que a finalidade de uso dos Dados Pessoais seja atingida, via
							de regra. Porém, os dados também podem ser mantidos
							<b>(i) </b>pelo tempo exigido por lei; <b>(ii) </b>até o término
							do Tratamento de Dados Pessoais por requisição do Titular;
							<b>(iii) </b>pelo tempo necessário a preservar nosso legítimo
							interesse, conforme o caso; <b>(iv) </b>pelo tempo necessário para
							resguardar o exercício regular de direitos da <b>Pilar </b>em
							processo judicial, administrativo ou
						</p>
						<p
							class="s5"
							style="padding-left: 5pt; text-indent: 0pt; text-align: left"
						>
							arbitral.
						</p>
					</td>
				</tr>
				<tr style="height: 15pt">
					<td
						style="
							width: 225pt;
							border-top-style: solid;
							border-top-width: 1pt;
							border-top-color: #0f4f3c;
							border-left-style: solid;
							border-left-width: 1pt;
							border-left-color: #0f4f3c;
							border-bottom-style: solid;
							border-bottom-width: 1pt;
							border-bottom-color: #0f4f3c;
							border-right-style: solid;
							border-right-width: 1pt;
							border-right-color: #0f4f3c;
						"
					>
						<p
							class="s4"
							style="
								padding-right: 4pt;
								text-indent: 0pt;
								line-height: 13pt;
								text-align: center;
							"
						>
							QUAL O MEIO DE CONTATO?
						</p>
					</td>
					<td
						style="
							width: 226pt;
							border-top-style: solid;
							border-top-width: 1pt;
							border-top-color: #0f4f3c;
							border-left-style: solid;
							border-left-width: 1pt;
							border-left-color: #0f4f3c;
							border-bottom-style: solid;
							border-bottom-width: 1pt;
							border-bottom-color: #0f4f3c;
							border-right-style: solid;
							border-right-width: 1pt;
							border-right-color: #0f4f3c;
						"
					>
						<p
							style="
								padding-top: 1pt;
								padding-left: 51pt;
								text-indent: 0pt;
								text-align: left;
							"
						>
							<a href="mailto:privacidade@soupilar.com.br" class="s7"
								>privacidade@soupilar.com.br</a
							>
						</p>
					</td>
				</tr>
			</tbody>
		</table>
		<h1
			style="
				padding-top: 1pt;
				padding-left: 5pt;
				text-indent: 0pt;
				text-align: center;
			"
		>
			QUADRO-RESUMO
		</h1>
		<p
			style="
				padding-top: 1pt;
				padding-left: 5pt;
				text-indent: 0pt;
				text-align: justify;
			"
		>
			Para facilitar a sua compreensão, Nós dividimos esta Política de
			Privacidade da seguinte forma:
		</p>
		<ol id="l3">
			<li data-list-text="1.">
				<h1
					style="
						padding-top: 17pt;
						padding-left: 28pt;
						text-indent: -23pt;
						text-align: left;
					"
				>
					COMO COLETAMOS SEUS DADOS PESSOAIS?<span class="s8"> </span
					><span class="p">4</span>
				</h1>
			</li>
			<li data-list-text="2.">
				<h1
					style="
						padding-top: 2pt;
						padding-left: 28pt;
						text-indent: -23pt;
						text-align: left;
					"
				>
					QUAIS DADOS PESSOAIS SÃO COLETADOS E PARA QUAL FINALIDADE?<span
						class="s8"
					>
					</span
					><span class="p">5</span>
				</h1>
			</li>
			<li data-list-text="3.">
				<h1
					style="
						padding-top: 2pt;
						padding-left: 28pt;
						text-indent: -23pt;
						text-align: left;
					"
				>
					PARA QUAIS FINALIDADES SÃO UTILIZADOS OS DADOS PESSOAIS?<span
						class="s8"
					>
					</span
					><span class="p">6</span>
				</h1>
			</li>
			<li data-list-text="4.">
				<h1
					style="
						padding-top: 2pt;
						padding-left: 28pt;
						text-indent: -23pt;
						text-align: left;
					"
				>
					COM QUEM COMPARTILHAMOS SEUS DADOS PESSOAIS?<span class="s8"> </span
					><span class="p">7</span>
				</h1>
			</li>
			<li data-list-text="5.">
				<h1
					style="
						padding-top: 2pt;
						padding-left: 28pt;
						text-indent: -23pt;
						text-align: left;
					"
				>
					POR QUANTO TEMPO ARMAZENAMOS OS SEUS DADOS?<span class="s8"> </span
					><span class="p">8</span>
				</h1>
			</li>
			<li data-list-text="6.">
				<h1
					style="
						padding-top: 2pt;
						padding-left: 28pt;
						text-indent: -23pt;
						text-align: left;
					"
				>
					QUAIS SÃO SEUS DIREITOS ENQUANTO TITULAR DOS DADOS PESSOAIS?<span
						class="s8"
					>
					</span
					><span class="p">9</span>
				</h1>
			</li>
			<li data-list-text="7.">
				<h1
					style="
						padding-top: 2pt;
						padding-left: 28pt;
						text-indent: -23pt;
						text-align: left;
					"
				>
					COMO GARANTIMOS A SEGURANÇA DE SEUS DADOS PESSOAIS?<span class="s8">
					</span
					><span class="p">10</span>
				</h1>
			</li>
		</ol>
		<ol id="l4">
			<li data-list-text="9.">
				<h1
					style="
						padding-top: 2pt;
						padding-left: 28pt;
						text-indent: -23pt;
						text-align: left;
					"
				>
					ALTERAÇÃO DESTA POLÍTICA DE PRIVACIDADE<span class="s8"> </span
					><span class="p">12</span>
				</h1>
			</li>
			<li data-list-text="10.">
				<h1
					style="
						padding-top: 2pt;
						padding-left: 26pt;
						text-indent: -21pt;
						text-align: left;
					"
				>
					ALGUMA DÚVIDA?<span class="s8"> </span><span class="p">12</span>
				</h1>
			</li>
		</ol>
		<p style="padding-top: 4pt; text-indent: 0pt; text-align: left"><br /></p>
		<p
			style="
				padding-left: 5pt;
				text-indent: 0pt;
				line-height: 114%;
				text-align: justify;
			"
		>
			Antes de seguirmos com as informações sobre os seus Dados Pessoais, Nós
			separamos alguns termos técnicos que Você poderá encontrar durante esse
			documento e explicamos cada um de seus conceitos:
		</p>
		<p style="padding-top: 2pt; text-indent: 0pt; text-align: left"><br /></p>
		<ul id="l5">
			<li data-list-text="●">
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					<b>Autoridade Nacional de Proteção de Dados </b>ou
					&quot;<b>ANPD</b>&quot;: órgão responsável pela
					<span class="s9">fi</span>scalização do cumprimento das disposições da
					LGPD no território brasileiro;
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="●">
				<h1
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Cliente:
					<span class="p"
						>comprador ou vendedor de um imóvel que está em contato com um
						corretor de imóveis parte do time </span
					>Pilar<span class="p">;</span>
				</h1>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="●">
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					<b>Controlador(a)</b>: a quem competem as decisões referentes ao
					Tratamento de Dados Pessoais, especialmente relativas às
					<span class="s9">fi</span>nalidades e aos meios de Tratamento;
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="●">
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					<b>Corretor de imóveis (“Corretor”): </b>usuário dos serviços
					oferecidos pela <b>Pilar</b>, incluindo a plataforma disponível
					<i>online </i>e por aplicativo mobile;
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="●">
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					<b>Dados Pessoais</b>: qualquer informação relacionada a pessoa
					natural identi<span class="s9">fi</span>cada ou identi<span class="s9"
						>fi</span
					>cável, como: nome, CPF, RG, endereço residencial ou comercial, número
					de telefone <span class="s9">fi</span>xo ou móvel, endereço de e-mail,
					endereço de IP, localização, dentre outros;
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="●">
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					<b>Dados Pessoais Sensíveis</b>: Dado Pessoal sobre origem racial ou
					étnica, convicção religiosa, opinião política,
					<span class="s9">fi</span>liação a sindicato ou a organização de
					caráter religioso, <span class="s9">fi</span>losó<span class="s9"
						>fi</span
					>co ou político, dado referente à saúde ou à vida sexual, dado
					genético ou biométrico, quando vinculado a uma pessoa natural;
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="●">
				<h1
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Encarregado<span class="p"
						>: pessoa indicada pelo Controlador e Operador para atuar como canal
						de comunicação entre o Controlador, os Titulares e a Autoridade
						Nacional de Proteção de Dados (ANPD);</span
					>
				</h1>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="●">
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					<b>Incidente(s)</b>: qualquer acesso, aquisição, uso, modi<span
						class="s9"
						>fi</span
					>cação, divulgação, perda, destruição ou dano acidental, ilegal ou não
					autorizado que envolva Dados Pessoais;
				</p>
			</li>
			<li data-list-text="●">
				<h1
					style="
						padding-top: 3pt;
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Lei Geral de Proteção de Dados
					<span class="p">ou &quot;</span>LGPD<span class="p"
						>&quot;: Lei Federal nº 13.709/2018 que regula o Tratamento de Dados
						Pessoais;</span
					>
				</h1>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="●">
				<h1
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Operador(a)<span class="p"
						>: pessoa natural ou jurídica, de direito público ou privado, que
						realiza o Tratamento de Dados Pessoais em nome do Controlador;</span
					>
				</h1>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="●">
				<h1
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Representante da marca (“Representante”):
					<span class="p">responsável pela imobiliária parceira da </span>Pilar
					<span class="p"
						>e que comporta os corretores de imóveis usuários da plataforma
						Pilar;</span
					>
				</h1>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="●">
				<h1
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Terceiro:
					<span class="p"
						>clientes, parceiros, fornecedores, representantes de clientes ou
						qualquer ente que seja externo à Pilar e tenha seus Dados Pessoais
						tratados;</span
					>
				</h1>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="●">
				<h1
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Titular ou Você:
					<span class="p"
						>pessoa natural a quem se referem os Dados Pessoais que são objeto
						de tratamento. Dentro do conjunto de atividades realizadas pela </span
					>Pilar<span class="p"
						>, titulares podem ser Clientes, Corretores e Representantes.</span
					>
				</h1>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="●">
				<h1
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Tratamento:
					<span class="p"
						>qualquer operação ou conjunto de operações efetuadas com Dados
						Pessoais ou sobre conjuntos de Dados Pessoais, por meios
						automatizados ou não automatizados, tais como a coleta, o registro,
						a organização, a estruturação, a conservação, a adaptação ou
						alteração, a recuperação, a consulta, a utilização, a divulgação por
						transmissão, difusão ou qualquer outra forma de disponibilização, a
						comparação ou interconexão, a limitação, a eliminação ou a
						destruição.</span
					>
				</h1>
			</li>
		</ul>
		<p style="padding-top: 2pt; text-indent: 0pt; text-align: left"><br /></p>
		<p
			style="
				padding-left: 5pt;
				text-indent: 0pt;
				line-height: 114%;
				text-align: left;
			"
		>
			Caso surja um conceito novo que não esteja esclarecido, consulte o artigo
			5º da
			<a
				href="https://www.planalto.gov.br/ccivil_03/_ato2015-2018/2018/lei/l13709.htm"
				class="a"
				target="_blank"
				><span
					style="
						color: #0462c1;
						font-family: Calibri, sans-serif;
						font-style: normal;
						font-weight: normal;
						text-decoration: underline;
						font-size: 11pt;
					"
					>LGPD</span
				></a
			>
			<span style="color: #000"> para saber mais.</span>
		</p>
		<p style="padding-top: 2pt; text-indent: 0pt; text-align: left"><br /></p>
		<ol id="l6">
			<li data-list-text="1.">
				<h1 style="padding-left: 40pt; text-indent: -35pt; text-align: justify">
					COMO COLETAMOS SEUS DADOS PESSOAIS?
				</h1>
				<p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: left;
					"
				>
					Os Dados Pessoais são tratados quando são necessários para atingir as
					finalidades mencionadas nesta Política de Privacidade. Para
					viabilizá-las, Nós poderemos coletar os seus Dados Pessoais:
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<ul id="l7">
					<li data-list-text="●">
						<p
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							diretamente com Você, por ser o Titular desses dados, quando
							participa de um evento conosco, demonstra interesse em fazer parte
							de nossa comunidade ou se cadastra em nossa Plataforma;
						</p>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<p
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							com alguém relacionado a Nós, por exemplo, uma imobiliária que nos
							envie dados cadastrais de Clientes para formalizar uma compra de
							imóvel ou um Corretor inclua dados de Clientes interessados em um
							imóvel; ou
						</p>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<p
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							automaticamente, ou seja, pelos registros armazenados quando Você
							navega pelo nosso site.
						</p>
					</li>
				</ul>
				<p style="text-indent: 0pt; text-align: left"><br /></p>
			</li>
			<li data-list-text="2.">
				<h1 style="padding-left: 40pt; text-indent: -35pt; text-align: justify">
					QUAIS DADOS PESSOAIS SÃO COLETADOS E PARA QUAL FINALIDADE?
				</h1>
				<p
					style="
						padding-top: 2pt;
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: left;
					"
				>
					Nós somos responsáveis pelo Tratamento de Dados Pessoais de diversas
					categorias a partir do seu acesso, cadastro e utilização de nossa
					Plataforma, como mostra a tabela abaixo:
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<table
					style="border-collapse: collapse; margin-left: 5.5pt"
					cellspacing="0"
				>
					<tbody>
						<tr style="height: 53pt">
							<td
								style="
									width: 106pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
								bgcolor="#D9D9D9"
							>
								<p
									class="s4"
									style="
										padding-top: 11pt;
										padding-left: 30pt;
										padding-right: 8pt;
										text-indent: -27pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Categoria dos Dados Pessoais
								</p>
							</td>
							<td
								style="
									width: 85pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
								bgcolor="#D9D9D9"
							>
								<p
									class="s4"
									style="
										padding-top: 11pt;
										padding-left: 24pt;
										padding-right: 11pt;
										text-indent: -7pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Quem é o Titular
								</p>
							</td>
							<td
								style="
									width: 106pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
								bgcolor="#D9D9D9"
							>
								<p
									class="s4"
									style="
										padding-top: 4pt;
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: center;
									"
								>
									Como são os Dados Pessoais são coletados
								</p>
							</td>
							<td
								style="
									width: 149pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
								bgcolor="#D9D9D9"
							>
								<p
									class="s4"
									style="
										padding-top: 11pt;
										padding-left: 52pt;
										text-indent: -39pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Quais Dados Pessoais são tratados
								</p>
							</td>
						</tr>
						<tr style="height: 178pt">
							<td
								style="
									width: 106pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s4"
									style="
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Dados Cadastrais
								</p>
							</td>
							<td
								style="
									width: 85pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s5"
									style="
										padding-left: 7pt;
										padding-right: 11pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: center;
									"
								>
									Corretor, Cliente e Representante
								</p>
							</td>
							<td
								style="
									width: 106pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s5"
									style="
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Dados fornecidos diretamente pelo Titular
								</p>
							</td>
							<td
								style="
									width: 149pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Dentre os dados coletados estão nome completo, CPF/RG, número
									de telefone, data de nascimento, endereço completo, e-mail e
									nacionalidade.
								</p>
								<p
									class="s5"
									style="
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Todavia, também poderemos solicitar que Você nos envie
									informações ou responda a perguntas adicionais que nos
									ajudarão a te identificar.
								</p>
							</td>
						</tr>
						<tr style="height: 69pt">
							<td
								style="
									width: 106pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="padding-top: 5pt; text-indent: 0pt; text-align: left">
									<br />
								</p>
								<p
									class="s4"
									style="
										padding-left: 35pt;
										padding-right: 8pt;
										text-indent: -30pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Dados Financeiros e Fiscais
								</p>
							</td>
							<td
								style="
									width: 85pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s5"
									style="
										padding-right: 4pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Cliente
								</p>
							</td>
							<td
								style="
									width: 106pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 3pt;
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Dados fornecidos por Terceiros e diretamente pelo Titular
								</p>
							</td>
							<td
								style="
									width: 149pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 3pt;
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Podemos coletar situação do Titular na Fazenda Pública,
									certidão negativa de débito (CVM), consulta à lista OFAC..
								</p>
							</td>
						</tr>
						<tr style="height: 84pt">
							<td
								style="
									width: 106pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s4"
									style="
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Dados Profissionais
								</p>
							</td>
							<td
								style="
									width: 85pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s5"
									style="
										padding-right: 4pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Corretor
								</p>
							</td>
							<td
								style="
									width: 106pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="padding-top: 5pt; text-indent: 0pt; text-align: left">
									<br />
								</p>
								<p
									class="s5"
									style="
										padding-left: 3pt;
										padding-right: 23pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Dados fornecidos diretamente pelo Titular
								</p>
							</td>
							<td
								style="
									width: 149pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 3pt;
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Registro no CRECI, área de atuação, extensão geográfica de
									atuação e descrição do histórico profissional (campo aberto).
								</p>
							</td>
						</tr>
						<tr style="height: 146pt">
							<td
								style="
									width: 106pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s4"
									style="
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Registros de Acesso
								</p>
							</td>
							<td
								style="
									width: 85pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s5"
									style="
										padding-left: 7pt;
										padding-right: 11pt;
										text-indent: 9pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Corretor e Representante
								</p>
							</td>
							<td
								style="
									width: 106pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s5"
									style="
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Dados coletados automaticamente
								</p>
							</td>
							<td
								style="
									width: 149pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Endereço de IP, data e hora de acesso, geolocalização precisa
									ou aproximada, dados de GPS, log de acesso, tipo de browser,
									tipo de dispositivo, modelo de hardware, dados de rede,
									sistema operacional e navegador utilizado, e outras
									informações semelhantes.
								</p>
							</td>
						</tr>
						<tr style="height: 85pt">
							<td
								style="
									width: 106pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s4"
									style="
										padding-top: 12pt;
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: center;
									"
								>
									Dados coletados por meio de Cookies e tecnologias assemelhadas
								</p>
							</td>
							<td
								style="
									width: 85pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s5"
									style="
										padding-left: 7pt;
										padding-right: 11pt;
										text-indent: 9pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Corretor e Representante
								</p>
							</td>
							<td
								style="
									width: 106pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Coletados automaticamente por Nós a partir do uso da
									Plataforma pelo Titular.
								</p>
							</td>
							<td
								style="
									width: 149pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 12pt;
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Poderemos utilizar Cookies e identificadores de dispositivos
									eletrônicos quando o Usuário utilizar a Plataforma.
								</p>
							</td>
						</tr>
					</tbody>
				</table>
				<ol id="l8">
					<li data-list-text="2.1.">
						<h1
							style="
								padding-top: 2pt;
								padding-left: 24pt;
								text-indent: -19pt;
								text-align: left;
							"
						>
							O TRATAMENTO DE DADOS PESSOAIS DE MENORES DE IDADE
						</h1>
						<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
						<p
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Via de regra a Pilar não trata Dados de menores de idade. A Pilar
							solicita a data de nascimento durante o cadastro de identificação
							do Corretor. Caso Você identifique que Dados Pessoais de um menor
							de 18 anos estejam sendo veiculadas em conteúdos publicados na
							Plataforma ou que um Usuário é menor de 18 anos, solicitamos que
							Você notifique a Pilar para que possamos remover referido conteúdo
							da Plataforma e/ou excluir a conta do Usuário, conforme o caso.
						</p>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
				</ol>
			</li>
			<li data-list-text="3.">
				<h1 style="padding-left: 40pt; text-indent: -35pt; text-align: left">
					PARA QUAIS FINALIDADES SÃO UTILIZADOS OS DADOS PESSOAIS?
				</h1>
				<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Nós utilizaremos os Dados Pessoais descritos no item acima para as
					seguintes finalidades e de acordo com a base legal aplicável:
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<table
					style="border-collapse: collapse; margin-left: 5.5pt"
					cellspacing="0"
				>
					<tbody>
						<tr style="height: 23pt">
							<td
								style="
									width: 127pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
								bgcolor="#D9D9D9"
							>
								<p
									class="s4"
									style="
										padding-top: 4pt;
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Finalidade
								</p>
							</td>
							<td
								style="
									width: 320pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
								bgcolor="#D9D9D9"
							>
								<p
									class="s4"
									style="
										padding-top: 4pt;
										padding-right: 4pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Explicação
								</p>
							</td>
						</tr>
						<tr style="height: 38pt">
							<td
								style="
									width: 127pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s4"
									style="
										padding-top: 4pt;
										padding-left: 15pt;
										padding-right: 19pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Criação de conta de acesso à Plataforma
								</p>
							</td>
							<td
								style="
									width: 320pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 3pt;
										padding-right: 12pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Utilizaremos Dados Pessoais do Corretor para identificar,
									autenticar e individualizá-los na Plataforma para permitir seu
									acesso.
								</p>
							</td>
						</tr>
						<tr style="height: 69pt">
							<td
								style="
									width: 127pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s4"
									style="
										padding-top: 12pt;
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: center;
									"
								>
									Prestar os serviços oferecidos pela Plataforma Pilar
								</p>
							</td>
							<td
								style="
									width: 320pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Trataremos Dados Pessoais de Corretores, Clientes e
									Representantes para prestar os serviços oferecidos pela
									<b>Pilar</b>, os quais derivam do suporte em marketing, vendas
									e networking aos Corretores e parceria com imobiliárias.
								</p>
							</td>
						</tr>
						<tr style="height: 69pt">
							<td
								style="
									width: 127pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s4"
									style="
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Divulgação e Marketing
								</p>
							</td>
							<td
								style="
									width: 320pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Nós trataremos Dados Pessoais de Corretores e Clientes a
									partir de gestão de redes sociais, incluindo métrica de dados
									automatizados dos Clientes, acompanhamento de <i>leads </i>por
									parte dos Corretores, sessão de fotos e vídeos para
									Corretores.
								</p>
							</td>
						</tr>
						<tr style="height: 54pt">
							<td
								style="
									width: 127pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p style="padding-top: 6pt; text-indent: 0pt; text-align: left">
									<br />
								</p>
								<p
									class="s11"
									style="
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Know Your Client <span class="s4">(“KYC”</span>)
								</p>
							</td>
							<td
								style="
									width: 320pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Nós poderemos tratar Dados Pessoais para analisar informações
									prévias a compras a respeito dos Clientes. Essas informações
									são coletadas de banco de dados terceiro contratado pela
									<b>Pilar</b>.
								</p>
							</td>
						</tr>
						<tr style="height: 52pt">
							<td
								style="
									width: 127pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p style="padding-top: 5pt; text-indent: 0pt; text-align: left">
									<br />
								</p>
								<p
									class="s11"
									style="
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Newsletter
								</p>
							</td>
							<td
								style="
									width: 320pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 3pt;
										padding-left: 3pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Nós trataremos seus Dados Pessoais para te enviar boletins
									informativos e outros tipos de comunicação por e-mail e
									WhatsApp.
								</p>
							</td>
						</tr>
						<tr style="height: 54pt">
							<td
								style="
									width: 127pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s4"
									style="
										padding-top: 11pt;
										padding-left: 38pt;
										padding-right: 8pt;
										text-indent: -35pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Realização de workshops e eventos
								</p>
							</td>
							<td
								style="
									width: 320pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Poderemos tratar Dados Pessoais de Corretores, Representantes
									ou outros participantes de eventos promovidos pela
									<b>Pilar </b>para realizar inscrições e registrar os
									presentes.
								</p>
							</td>
						</tr>
						<tr style="height: 99pt">
							<td
								style="
									width: 127pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s4"
									style="
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: center;
									"
								>
									Cumprimento de obrigações legais ou regulatórias da Nova
								</p>
							</td>
							<td
								style="
									width: 320pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 3pt;
										padding-left: 3pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: justify;
									"
								>
									Trataremos Dados Pessoais do Usuário para cumprir com suas
									obrigações legais e/ou regulatórias na medida do que for
									necessário. Essas obrigações podem incluir, por exemplo,
									obrigações fiscais e tributárias, obrigações sobre manutenção
									de registros técnicos, documentação de serviços contratados,
									prestação de contas, entre outras.
								</p>
							</td>
						</tr>
					</tbody>
				</table>
				<table
					style="border-collapse: collapse; margin-left: 5.5pt"
					cellspacing="0"
				>
					<tbody>
						<tr style="height: 20pt">
							<td
								style="
									width: 127pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s4"
									style="
										padding-top: 3pt;
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Exercício de direitos
								</p>
							</td>
							<td
								style="
									width: 320pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-top-color: #0f4f3c;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 3pt;
										padding-left: 3pt;
										text-indent: 0pt;
										text-align: left;
									"
								>
									Poderemos tratar seus Dados Pessoais para exercer seus
									próprios
								</p>
							</td>
						</tr>
						<tr style="height: 16pt">
							<td
								style="
									width: 127pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s4"
									style="
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									relacionados a processos
								</p>
							</td>
							<td
								style="
									width: 320pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s5"
									style="padding-left: 3pt; text-indent: 0pt; text-align: left"
								>
									direitos e/ou para defender seus direitos e interesses. Isso
									pode
								</p>
							</td>
						</tr>
						<tr style="height: 16pt">
							<td
								style="
									width: 127pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s4"
									style="
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									judiciais e
								</p>
							</td>
							<td
								style="
									width: 320pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s5"
									style="padding-left: 3pt; text-indent: 0pt; text-align: left"
								>
									incluir tratativas extrajudiciais entre as partes, processos
									judiciais ou
								</p>
							</td>
						</tr>
						<tr style="height: 19pt">
							<td
								style="
									width: 127pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s4"
									style="
										padding-left: 1pt;
										padding-right: 5pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									administrativos
								</p>
							</td>
							<td
								style="
									width: 320pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-left-color: #0f4f3c;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-bottom-color: #0f4f3c;
									border-right-style: solid;
									border-right-width: 1pt;
									border-right-color: #0f4f3c;
								"
							>
								<p
									class="s5"
									style="padding-left: 3pt; text-indent: 0pt; text-align: left"
								>
									arbitrais, procedimentos administrativos, entre outros.
								</p>
							</td>
						</tr>
					</tbody>
				</table>
				<p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					O Tratamento de Dados Pessoais pela Pilar será fundamentado nas bases
					legais aplicáveis para cada caso. Essas bases legais incluem execução
					de um contrato ou providências preliminares; cumprimento de obrigações
					legais ou regulatórias; exercício e defesa de direitos e interesses da
					Pilar; ou um interesse legítimo da Pilar, sempre considerando e
					respeitando os direitos e garantias fundamentais asseguradas ao
					Titular dos Dados Pessoais; ou ainda, com base no Consentimento,
					quando expressamente solicitado pela Pilar na Plataforma.
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					<u>Ressaltamos que Você poderá se descadastrar de nosso </u
					><u><i>mailing </i></u><u>caso não queira mais receber</u>
					<u
						>nossos boletins ou comunicações publicitárias. Para isso, basta
						sair do grupo do WhatsApp, seguir</u
					>
					<u
						>as&nbsp; instruções&nbsp; dispostas&nbsp; ao&nbsp; final&nbsp;
						do&nbsp; e-mail&nbsp; enviado pela </u
					><u><b>Pilar </b></u><u>ou nos comunicar via o canal</u>
					<a href="mailto:cs@soupilar.com.br" class="s14" target="_blank"
						>[<u>cs@soupilar.com.br]</u></a
					>.
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="4.">
				<h1 style="padding-left: 40pt; text-indent: -35pt; text-align: justify">
					COM QUEM COMPARTILHAMOS SEUS DADOS PESSOAIS?
				</h1>
				<p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p style="padding-left: 5pt; text-indent: 0pt; text-align: justify">
					Nós poderemos compartilhar os seus Dados Pessoais com:
				</p>
				<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<ul id="l9">
					<li data-list-text="●">
						<h1
							style="
								padding-left: 40pt;
								text-indent: -35pt;
								text-align: justify;
							"
						>
							Corretores de imóveis,
							<span class="p"
								>quando recebermos Dados Pessoais diretamente do Cliente;</span
							>
						</h1>
						<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<h1
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Exercício regular de direitos por vias administrativas, judiciais
							ou extrajudiciais<span class="p"
								>: poderemos compartilhar Dados Pessoais com terceiros, como
								escritórios de advocacia, consultorias, empresas de cobrança,
								escritórios de contabilidade e similares, com o objetivo de
								exercer seus próprios direitos ou garantir o cumprimento e a
								aplicação desta Política de Privacidade e dos Termos e Condições
								de Uso;</span
							>
						</h1>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<h1
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Requisição Judicial ou Administrativa:
							<span class="p"
								>poderemos compartilhar Dados Pessoais em resposta a uma
								requisição judicial ou administrativa; e</span
							>
						</h1>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<h1
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Cumprimento de obrigação legal ou regulatória:
							<span class="p"
								>poderemos compartilhar Dados Pessoais com órgãos, autoridades e
								outras entidades governamentais, bem como com pessoas físicas ou
								jurídicas de natureza privada, para cumprir com obrigações
								legais ou regulatórias.</span
							>
						</h1>
					</li>
				</ul>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<ol id="l10">
					<li data-list-text="4.1.">
						<h1
							style="
								padding-left: 43pt;
								text-indent: -38pt;
								text-align: justify;
							"
						>
							TRANSFERÊNCIA INTERNACIONAL DE DADOS PESSOAIS
						</h1>
						<p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
						<p
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Via de regra a <b>Pilar </b>não transfere Dados Pessoais para o
							exterior, apenas em casos de armazenamento em nuvem, em que o
							servidor contratado pela <b>Pilar </b>está localizado nos Estados
							Unidos. Neste caso, seus Dados serão mantidos fora do Brasil pelo
							período em que oferecermos os serviços a Você ou que precisemos
							armazenar em situações excepcionais, como cumprimento de obrigação
							legal ou regulatória.
						</p>
						<p
							style="
								padding-top: 2pt;
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Para este e outros casos que envolvam a transferência
							internacional, Nós adotamos as medidas apropriadas para garantir a
							proteção adequada em conformidade com os requisitos da LGPD,
							incluindo, a realização de contratos apropriados para a
							transferência de dados com Terceiros, quando aplicável.
						</p>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
				</ol>
			</li>
			<li data-list-text="5.">
				<h1 style="padding-left: 40pt; text-indent: -35pt; text-align: left">
					POR QUANTO TEMPO ARMAZENAMOS OS SEUS DADOS?
				</h1>
				<p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Nossa responsabilidade é cuidar dos seus Dados Pessoais e utilizá-los
					somente para as <span class="s9">fi</span>nalidades delimitadas pela
					<b>Pilar </b>e exemplificadas nesta Política.
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Porém, também poderemos manter seus Dados Pessoais: (i) pelo tempo
					exigido por lei; (ii) até o término do Tratamento; (iii) pelo tempo
					necessário a preservar nosso legítimo interesse, conforme o caso; ou
					(iv) pelo tempo necessário para resguardar o nosso exercício regular
					de direitos em processo judicial, administrativo ou arbitral. Assim,
					trataremos seus dados, por exemplo, para o cumprimento de quaisquer
					obrigações legais, regulatórias, contratuais, para resguardar os
					direitos da <b>Pilar</b>, entre outras.
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					O término do Tratamento de Dados Pessoais ocorrerá quando a finalidade
					para a qual coletamos os seus Dados Pessoais for alcançada e/ou os
					Dados Pessoais coletados deixarem de ser necessários ou pertinentes ao
					alcance de tal finalidade; quando Você nos solicitar a exclusão de
					seus Dados Pessoais; ou quando houver uma determinação legal. Quando
					houver o término do Tratamento, os Dados Pessoais serão eliminados.
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					EM OBSERVÂNCIA À LEGISLAÇÃO APLICÁVEL OU CUMPRIMENTO DE ORDEM
					JUDICIAL, A PILAR PODERÁ MANTER DETERMINADOS DADOS PESSOAIS SEUS
					ARMAZENADOS POR UM PERÍODO NÃO INFERIOR A 6 (SEIS) MESES, APÓS O SEU
					PEDIDO DE EXCLUSÃO. REFERIDOS DADOS NÃO SERÃO ANONIMIZADOS OU
					DESTRUÍDOS PELA PILAR ANTES DA CONCLUSÃO DESSE PRAZO. A PILAR
					ARMAZENARÁ A SUA SOLICITAÇÃO DE EXCLUSÃO E, OBSERVADO O PRAZO LEGAL DE
					GUARDA OBRIGATÓRIA DE ALGUNS DETERMINADOS DADOS, PROVIDENCIARÁ A
					DESTRUIÇÃO OU ANONIMIZAÇÃO, A CRITÉRIO EXCLUSIVO DA PILAR, DAS
					INFORMAÇÕES CAPAZES DE IDENTIFICAR O USUÁRIO. CASO O USUÁRIO SOLICITE
					A EXCLUSÃO DAS SUAS INFORMAÇÕES, MAS AINDA TENHA ALGUMA OBRIGAÇÃO
					PENDENTE DE CUMPRIMENTO COM A PILAR, AS SUAS INFORMAÇÕES NÃO SERÃO
					EXCLUÍDAS E PERMANECERÃO ARMAZENADAS PARA O FIM DE VIABILIZAR A
					SOLUÇÃO DA PENDÊNCIA E A ADOÇÃO DE MEDIDAS CABÍVEIS.
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="6.">
				<h1 style="padding-left: 40pt; text-indent: -35pt; text-align: left">
					QUAIS SÃO SEUS DIREITOS ENQUANTO TITULAR DOS DADOS PESSOAIS?
				</h1>
				<p style="padding-top: 3pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p style="padding-left: 5pt; text-indent: 0pt; text-align: justify">
					A LGPD traz uma lista de direitos ao Titular dos Dados Pessoais,
					sendo:
				</p>
				<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<ul id="l11">
					<li data-list-text="●">
						<h1
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: left;
							"
						>
							Confirmação da existência de tratamento<span class="p"
								>: Titulares podem confirmar se a </span
							>Pilar
							<span class="p">está tratando os seus Dados Pessoais;</span>
						</h1>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<h1
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: left;
							"
						>
							Acesso aos Dados Pessoais<span class="p"
								>: Titulares podem acessar os seus Dados Pessoais, inclusive
								solicitando cópia dos Dados Pessoais tratados;</span
							>
						</h1>
					</li>
					<li data-list-text="●">
						<h1
							style="
								padding-top: 3pt;
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Correção de Dados incompletos, inexatos ou desatualizados<span
								class="p"
								>: Titulares podem solicitar alteração ou correção dos seus
								Dados Pessoais que se apresentem incorretos;</span
							>
						</h1>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<h1
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Anonimização, bloqueio ou eliminação<span class="p"
								>: Titulares podem solicitar a anonimização, bloqueio ou
								eliminação de dados desnecessários, excessivos ou tratados em
								desconformidade com o disposto na LGPD;</span
							>
						</h1>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<h1
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Portabilidade<span class="p"
								>: Titulares podem solicitar a portabilidade dos seus Dados por
								solicitação pelos canais de atendimento indicados nesta Política
								de Privacidade;</span
							>
						</h1>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<h1
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Eliminação dos Dados Pessoais<span class="p"
								>: Titulares podem solicitar a exclusão de seus Dados Pessoais
								tratados por Nós pelos canais de atendimento indicados nesta
								Política de Privacidade;</span
							>
						</h1>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<h1
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Informação sobre compartilhamento<span class="p"
								>: Titulares podem solicitar informação sobre com quais
								entidades públicas e privadas a </span
							>Pilar
							<span class="p"
								>compartilhou os seus Dados Pessoais, nos termos desta Política
								de Privacidade;</span
							>
						</h1>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<h1
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Informação sobre a possibilidade de não consentir<span class="p"
								>: Titulares e/ou pais e responsáveis legais devem saber que não
								são obrigados a conceder o consentimento para o Tratamento de
								Dados Pessoais caso a </span
							>Pilar
							<span class="p"
								>o solicite. Essa informação está garantida por meio dessa
								Política de Privacidade;</span
							>
						</h1>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<h1
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Revogação do Consentimento<span class="p"
								>: Titulares podem, a qualquer momento e a seu critério, revogar
								o Consentimento anteriormente fornecido para Tratamento de Dados
								Pessoais, permanecendo os tratamentos realizados com base nele,
								até tal momento, válidos;</span
							>
						</h1>
						<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
							<br />
						</p>
					</li>
					<li data-list-text="●">
						<h1
							style="
								padding-left: 5pt;
								text-indent: 0pt;
								line-height: 114%;
								text-align: justify;
							"
						>
							Direito de petição à Agência Nacional de Proteção de Dados (ANPD):
							os Titulares podem exercer seus direitos no caso de não
							atendimento às suas solicitações ou se a resposta dada pelo
							Controlador não tenha sido satisfatória, podendo comunicar a ANPD
							por meio de uma “petição de titular”, o qual pode ser acessado
							<a
								href="https://www.gov.br/anpd/pt-br/canais_atendimento/peticionamento-eletronico-anpd"
								class="a"
								target="_blank"
								><span
									style="
										color: #0462c1;
										font-family: Calibri, sans-serif;
										font-style: normal;
										font-weight: normal;
										text-decoration: underline;
										font-size: 11pt;
									"
									>aqui</span
								></a
							><span class="p">.</span>
						</h1>
					</li>
				</ul>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<h1
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Exercício dos seus direitos.
					<span class="p"
						>Você pode exercer os seus direitos aos nos contatar pelo canal
						divulgado nesta Política. Quando realizar o contato, pode ser que a </span
					>Pilar
					<span class="p"
						>peça mais informações ou documentos para comprovar as suas
						alegações. Porém ressaltamos que há circunstâncias que podem
						restringir o exercício de alguns direitos previstos em lei, como,
						por exemplo, quando o fornecimento das informações puder revelar
						algum segredo de negócio da </span
					>Pilar.
				</h1>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="7.">
				<h1 style="padding-left: 40pt; text-indent: -35pt; text-align: justify">
					COMO GARANTIMOS A SEGURANÇA DE SEUS DADOS PESSOAIS?
				</h1>
				<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Nós temos um compromisso com a segurança dos seus Dados Pessoais e
					adotamos todas as medidas técnicas e organizacionais razoáveis e
					disponíveis no mercado para manter essa proteção. Utilizamos sistemas
					de segurança e tomamos todas as precauções para proteger os seus Dados
					Pessoais e evitar qualquer tipo de Incidentes. No entanto, nenhum
					método de transmissão ou armazenamento de dados eletrônicos é
					totalmente seguro e está livre de eventuais ataques externos. Por
					isso, a <b>Pilar </b>não pode garantir a absoluta segurança das
					medidas adotadas ou a
				</p>
				<p
					style="
						padding-top: 2pt;
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					ausência de interferência de terceiros (como hackers). Por sua
					natureza, apesar de nossos melhores esforços, qualquer medida de
					segurança pode falhar, resultando em eventual Incidente envolvendo
					Dados Pessoais. Tais medidas se estendem aos Terceiros com os quais
					compartilhamos Dados Pessoais, considerando nossa ausência de
					responsabilidade em caso de incidentes, mas nosso cuidado em garantir
					parcerias que possuam o mínimo de boas práticas em segurança da
					informação. As medidas de segurança aqui descritas aplicam-se aos
					dados do Usuário somente a partir do momento em que a Pilar as recebe
					e enquanto as mantém sob sua guarda. O funcionamento e a segurança do
					dispositivo que os Usuários usam para acessar a Plataforma, bem como
					redes terceiras pelas quais os dados trafegam não são de
					responsabilidade da Pilar.
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Adicionalmente, destacamos que durante o uso da Plataforma, os
					Usuários podem vir a utilizar outros serviços, canais, produtos e
					plataformas fornecidas, mantidas e/ou operadas por terceiros,
					utilizadas como canais ou meios de apoio aos serviços prestados pela
					Pilar, mas sem qualquer relação com a Pilar (“<u
						>Serviços de Terceiros</u
					>”). Esses Serviços de Terceiros podem incluir, por exemplo,
					plataformas de redes sociais, ferramentas de compartilhamento de
					arquivos, entre outros. Nesses casos, os Usuários declaram ciência de
					que tais terceiros poderão tratar seus Dados Pessoais de acordo com as
					políticas de privacidade e termos de uso de tais Serviços de Terceiro,
					sobre os quais a Pilar não tem nenhum controle ou ingerência. A Pilar
					e esse terceiro serão Controladores Independentes dos Dados Pessoais,
					responsabilizando-se cada qual pelo Tratamento de Dados Pessoais
					realizados em sua esfera de atuação. No que concerne à Pilar, mesmo
					quando os Dados Pessoais sejam recebidos por tais Serviços de
					Terceiro, tais Dados Pessoais serão sempre tratados em conformidade
					com esta Política de Privacidade. Entretanto, encorajamos o Usuário a
					informar-se sobre as políticas aplicáveis a tais Serviços de
					Terceiros, uma vez que a Pilar não tem ingerência na relação entre o
					Usuário e tais Terceiros e não é responsável pelo uso feito por tais
					Terceiros dos Dados Pessoais do Usuário inseridos pelos Usuários nos
					Serviços de Terceiros.
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					NADA DO QUE ESTÁ ESCRITO NA POLÍTICA DE PRIVACIDADE TEM COMO INTENÇÃO
					EXCLUIR OU LIMITAR QUALQUER CONDIÇÃO, GARANTIA, DIREITO OU
					RESPONSABILIDADE QUE NÃO POSSA SER LEGALMENTE EXCLUÍDA OU LIMITADA.
					ALGUMAS JURISDIÇÕES NÃO PERMITEM A EXCLUSÃO DE CERTAS GARANTIAS OU
					CONDIÇÕES OU A LIMITAÇÃO OU EXCLUSÃO DE RESPONSABILIDADE POR PERDAS E
					DANOS. CONSEQUENTEMENTE, APENAS AS LIMITAÇÕES QUE FOREM PERMITIDAS POR
					LEI NA SUA JURISDIÇÃO SE APLICARÃO A VOCÊ. NOS CASOS EM QUE EXCLUSÃO
					DE RESPONSABILIDADE NÃO SE MOSTRAR POSSÍVEL, MAS A LIMITAÇÃO DE
					RESPONSABILIDADE FOR LEGALMENTE APLICÁVEL, A RESPONSABILIDADE TOTAL DA
					PILAR ESTARÁ LIMITADA A R$ 1.000,00 (MIL REAIS).
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="8.">
				<h1 style="padding-left: 40pt; text-indent: -35pt; text-align: left">
					COOKIES: O QUE SÃO E COMO COLETAMOS
				</h1>
				<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					class="s1"
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Cookies
					<span class="p"
						>são basicamente arquivos de internet que podem ser temporariamente
						armazenados em seus dispositivos. Nós utilizamos cookies para
						facilitar sua navegação em nosso site, adequando-o a seus interesses
						e necessidades. Eles também são importantes para nos fornecer
						informações sobre como nosso site e nossos serviços estão sendo
						utilizados, o que é fundamental para melhorar nosso
						relacionamento.</span
					>
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p style="padding-left: 5pt; text-indent: 0pt; text-align: justify">
					Os <i>cookies </i>podem armazenar certas informações, como o seu
					endereço IP, informações sobre o
				</p>
				<p
					style="
						padding-top: 2pt;
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					conteúdo que você visualiza, informações sobre o conteúdo que você
					fornece para que você não tenha que digitá-lo novamente cada vez que
					visitar nosso site e suas preferências e configurações, conforme
					abaixo:
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<table
					style="border-collapse: collapse; margin-left: 10.5pt"
					cellspacing="0"
				>
					<tbody>
						<tr style="height: 23pt">
							<td
								style="
									width: 235pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
								colspan="2"
								bgcolor="#D9D9D9"
							>
								<p
									class="s4"
									style="
										padding-top: 4pt;
										padding-left: 58pt;
										text-indent: 0pt;
										text-align: left;
									"
								>
									CATEGORIA DO COOKIES
								</p>
							</td>
							<td
								style="
									width: 213pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
								bgcolor="#D9D9D9"
							>
								<p
									class="s4"
									style="
										padding-top: 4pt;
										padding-right: 4pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									DESCRIÇÃO
								</p>
							</td>
						</tr>
						<tr style="height: 69pt">
							<td
								style="
									width: 100pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
								rowspan="2"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s15"
									style="padding-left: 18pt; text-indent: 0pt; text-align: left"
								>
									Necessidade
								</p>
							</td>
							<td
								style="
									width: 135pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s4"
									style="
										padding-right: 3pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Necessários
								</p>
							</td>
							<td
								style="
									width: 213pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 5pt;
										padding-right: 9pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: center;
									"
								>
									Cookies utilizados para que o site funcione corretamente e que
									sem eles Você e demais usuários não conseguiriam utilizar o
									principal serviço do aplicativo.
								</p>
							</td>
						</tr>
						<tr style="height: 54pt">
							<td
								style="
									width: 135pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="padding-top: 6pt; text-indent: 0pt; text-align: left">
									<br />
								</p>
								<p
									class="s4"
									style="
										padding-right: 3pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Não necessários
								</p>
							</td>
							<td
								style="
									width: 213pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 4pt;
										padding-right: 8pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: center;
									"
								>
									Cookies que, se desabilitados, não impedem a utilização do
									aplicativo de forma plena e o correto funcionamento.
								</p>
							</td>
						</tr>
						<tr style="height: 99pt">
							<td
								style="
									width: 100pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
								rowspan="3"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s15"
									style="padding-left: 23pt; text-indent: 0pt; text-align: left"
								>
									Finalidade
								</p>
							</td>
							<td
								style="
									width: 135pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s4"
									style="
										padding-right: 3pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Analíticos
								</p>
							</td>
							<td
								style="
									width: 213pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 3pt;
										padding-left: 5pt;
										padding-right: 9pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: center;
									"
								>
									Cookies que coletam informações sobre a navegação no
									aplicativo para fins estatísticos. Assim, iremos entender como
									Você utiliza a nossa plataforma, qual índice de erro do
									aplicativo com usuários, dentre outras informações.
								</p>
							</td>
						</tr>
						<tr style="height: 69pt">
							<td
								style="
									width: 135pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s4"
									style="
										padding-right: 3pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									de Funcionalidade
								</p>
							</td>
							<td
								style="
									width: 213pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 5pt;
										padding-right: 9pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: center;
									"
								>
									Cookies que oferecem o serviço básico do aplicativo e permitem
									lembrar preferências, como o seu nome de usuário, quando Você
									nos visitou, a sua localização e o seu idioma.
								</p>
							</td>
						</tr>
						<tr style="height: 85pt">
							<td
								style="
									width: 135pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s4"
									style="
										padding-right: 3pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									de Publicidade/Marketing
								</p>
							</td>
							<td
								style="
									width: 213pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 5pt;
										padding-right: 9pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: center;
									"
								>
									Cookies que constroem o seu perfil de usuário a partir de
									dados extraído do seu hábito de navegação e, a partir disso,
									conseguem direcionar anúncios e marketing a Você.
								</p>
							</td>
						</tr>
						<tr style="height: 38pt">
							<td
								style="
									width: 100pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
								rowspan="2"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s4"
									style="
										padding-left: 9pt;
										padding-right: 13pt;
										text-indent: 13pt;
										line-height: 114%;
										text-align: left;
									"
								>
									<u>Período de</u> <u>Armazenamento</u>
								</p>
							</td>
							<td
								style="
									width: 135pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s4"
									style="
										padding-top: 11pt;
										padding-right: 3pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Temporários
								</p>
							</td>
							<td
								style="
									width: 213pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 14pt;
										padding-right: 15pt;
										text-indent: -4pt;
										line-height: 114%;
										text-align: left;
									"
								>
									Cookies descartados quando Você deixa o nosso aplicativo ao
									encerrar sua sessão.
								</p>
							</td>
						</tr>
						<tr style="height: 69pt">
							<td
								style="
									width: 135pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p style="text-indent: 0pt; text-align: left"><br /></p>
								<p
									class="s4"
									style="
										padding-right: 3pt;
										text-indent: 0pt;
										text-align: center;
									"
								>
									Persistentes
								</p>
							</td>
							<td
								style="
									width: 213pt;
									border-top-style: solid;
									border-top-width: 1pt;
									border-left-style: solid;
									border-left-width: 1pt;
									border-bottom-style: solid;
									border-bottom-width: 1pt;
									border-right-style: solid;
									border-right-width: 1pt;
								"
							>
								<p
									class="s5"
									style="
										padding-top: 4pt;
										padding-left: 6pt;
										padding-right: 10pt;
										text-indent: 0pt;
										line-height: 114%;
										text-align: center;
									"
								>
									Cookies que permanecem armazenados mesmo após o encerramento
									de sua sessão e podem ter estabelecido um período definido de
									armazenamento.
								</p>
							</td>
						</tr>
					</tbody>
				</table>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Ao entrar em nosso site, Você deve ter visualizado um <i>pop-up </i>no
					canto inferior da página alertando sobre a utilização dessa ferramenta
					em sua primeira visita. Embora esse aviso não apareça nas visitas
					subsequentes, você pode gerenciar a utilização de cookies a qualquer
					momento ao clicar no ícone “<i>Informações do site</i>” de seu
					navegador, que se encontra ao lado do endereço eletrônico
					<a href="http://www.soupilar.com.br/" class="a" target="_blank"
						><span
							style="
								color: #0462c1;
								font-family: Calibri, sans-serif;
								font-style: normal;
								font-weight: normal;
								text-decoration: underline;
								font-size: 11pt;
							"
							>www.soupilar.com.br</span
						></a
					>.
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p style="padding-left: 5pt; text-indent: 0pt; text-align: justify">
					Ao usar nosso site e nosso aplicativo mobile, você reconhece o uso de
					cookies de acordo com as
				</p>
				<p
					style="
						padding-top: 2pt;
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					condições aqui descritas. Se você não concorda com o uso desses
					cookies, você pode desativá-los a qualquer momento, ajustando as
					configurações do seu navegador por meio do gerenciamento. Os
					navegadores são diferentes, portanto, consulte o menu de configurações
					do seu navegador para obter instruções sobre como alterar suas
					preferências de cookies. Se você optar por não receber cookies, nossos
					sites podem não funcionar corretamente e alguns recursos podem ficar
					indisponíveis.
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="9.">
				<h1 style="padding-left: 40pt; text-indent: -35pt; text-align: left">
					ALTERAÇÃO DESTA POLÍTICA DE PRIVACIDADE
				</h1>
				<p style="padding-top: 4pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
				<p
					style="
						padding-left: 5pt;
						text-indent: 0pt;
						line-height: 114%;
						text-align: justify;
					"
				>
					Nós poderemos revisar esta Política de Privacidade a qualquer tempo,
					seja pela utilização de novas tecnologias ou sempre que entendermos
					necessário. Quando ocorrer a revisão, publicaremos a versão atualizada
					em nosso site com a indicação da versão.
				</p>
				<p style="padding-top: 2pt; text-indent: 0pt; text-align: left">
					<br />
				</p>
			</li>
			<li data-list-text="10.">
				<h1 style="padding-left: 40pt; text-indent: -35pt; text-align: left">
					ALGUMA DÚVIDA?
				</h1>
			</li>
		</ol>
		<p style="padding-top: 3pt; text-indent: 0pt; text-align: left"><br /></p>
		<p
			style="
				padding-left: 5pt;
				text-indent: 0pt;
				line-height: 114%;
				text-align: left;
			"
		>
			Em caso de qualquer dúvida sobre o Tratamento de seus Dados Pessoais, Você
			pode nos contatar pelo canal
			<a href="mailto:privacidade@soupilar.com.br" target="_blank"
				>privacidade@soupilar.com.br.</a
			>
		</p>
	</div>
</template>

<script setup lang="ts">
import { urlSouPilar } from '~/constants';

definePageMeta({
	layout: 'empty'
});
</script>

<!-- eslint-disable-next-line custom-rules/no-style-tag -->
<style scoped>
* {
	margin: 0;
	padding: 0;
	text-indent: 0;
}
h1 {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
.s1 {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: italic;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
.p,
p {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
	margin: 0pt;
}
.a,
a {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
.s4 {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
.s5 {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
.s7 {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 10pt;
}
.s8 {
	color: black;
	font-family: 'Times New Roman', serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
.s9 {
	color: black;
	font-family: Arial, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
.s10 {
	color: #0462c1;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
.s11 {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: italic;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
.s14 {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: underline;
	font-size: 11pt;
}
.s15 {
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: underline;
	font-size: 11pt;
}
li {
	display: block;
}
#l1 {
	padding-left: 0pt;
}
#l1 > li > *:first-child:before {
	content: '● ';
	color: black;
	font-family: Arial, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
li {
	display: block;
}
#l2 {
	padding-left: 0pt;
}
#l2 > li > *:first-child:before {
	content: '● ';
	color: black;
	font-family: Arial, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
li {
	display: block;
}
#l3 {
	padding-left: 0pt;
	counter-reset: e1 1;
}
#l3 > li > *:first-child:before {
	counter-increment: e1;
	content: counter(e1, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l3 > li:first-child > *:first-child:before {
	counter-increment: e1 0;
}
li {
	display: block;
}
#l4 {
	padding-left: 0pt;
	counter-reset: f1 9;
}
#l4 > li > *:first-child:before {
	counter-increment: f1;
	content: counter(f1, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l4 > li:first-child > *:first-child:before {
	counter-increment: f1 0;
}
li {
	display: block;
}
#l5 {
	padding-left: 0pt;
}
#l5 > li > *:first-child:before {
	content: '● ';
	color: black;
	font-family: Arial, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
}
li {
	display: block;
}
#l6 {
	padding-left: 0pt;
	counter-reset: h1 1;
}
#l6 > li > *:first-child:before {
	counter-increment: h1;
	content: counter(h1, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l6 > li:first-child > *:first-child:before {
	counter-increment: h1 0;
}
#l7 {
	padding-left: 0pt;
}
#l7 > li > *:first-child:before {
	content: '● ';
	color: black;
	font-family: Arial, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
#l8 {
	padding-left: 0pt;
	counter-reset: h2 1;
}
#l8 > li > *:first-child:before {
	counter-increment: h2;
	content: counter(h1, decimal) '.' counter(h2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l8 > li:first-child > *:first-child:before {
	counter-increment: h2 0;
}
#l9 {
	padding-left: 0pt;
}
#l9 > li > *:first-child:before {
	content: '● ';
	color: black;
	font-family: Arial, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
#l10 {
	padding-left: 0pt;
	counter-reset: h2 1;
}
#l10 > li > *:first-child:before {
	counter-increment: h2;
	content: counter(h1, decimal) '.' counter(h2, decimal) '. ';
	color: black;
	font-family: Calibri, sans-serif;
	font-style: normal;
	font-weight: bold;
	text-decoration: none;
	font-size: 11pt;
}
#l10 > li:first-child > *:first-child:before {
	counter-increment: h2 0;
}
#l11 {
	padding-left: 0pt;
}
#l11 > li > *:first-child:before {
	content: '● ';
	color: black;
	font-family: Arial, sans-serif;
	font-style: normal;
	font-weight: normal;
	text-decoration: none;
	font-size: 11pt;
}
table,
tbody {
	vertical-align: top;
	overflow: visible;
}
.updated-at {
	text-align: left;
	@media screen and (min-width: 640px) {
		text-indent: 20pt;
	}
}
</style>
